// extracted by mini-css-extract-plugin
export default {"cls1":"useImageAttachment-cls1___435b8e60c19f4e1bd37","cls2":"useImageAttachment-cls2__cc51a30a30f48309a62d useImageAttachment-cls1___435b8e60c19f4e1bd37"};